import { Component, Input, ChangeDetectionStrategy } from '@angular/core'
import { Guest } from '@tv3/store/guest/guest.model'

@Component({
  selector: 'app-guest-invoice-info',
  templateUrl: './guest-info.component.html',
  styleUrls: ['./guest-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class GuestInfoComponent {
  @Input() guest: Guest
}
